import React, {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {ApplicationSourceSection} from "../application/utils/ApplicationSource";
import {ColumnList} from "../atoms/ColumnList";
import {ColumnListItem} from "../atoms/ColumnListItem";
import {OfferBox} from "../offer/components/offer_box/OfferBox";
import {OfferModal} from "../offer/components/offer_modal/OfferModal";
import {showOfferModal} from "../offer/state/offer_modals_slice";
import {IOfferListOffer} from "../offer/types/IOfferListOffer";
import {IOfferModalName} from "../offer/types/OfferModalName";
import {IOfferModalOffer} from "../offer/types/OfferModalOffer";
import {Country} from "../region/types/Country";
import {useAppDispatch} from "../store/hooks";
import {useGTMEcommerceShortOfferListTracking} from "../tracking/hooks/use_gtm_ecommerce_tracking";
import {useUserPreferencesFilters} from "../user/hooks/use_user_preferences_filters";

interface IProps {
    offersNearby: IOfferListOffer[];
    modalQuery: IInfiniteListQuery<IOfferModalOffer>;
    lastElement?: JSX.Element;
    onBoxClick?: (e: React.MouseEvent, offerId: number) => void;
    gtmData: {
        listingName: string;
        country: Country;
    };
}

const FIRST_NEARBY_ELEMENT_ID = "first-nearby-element";
const modalName: IOfferModalName = "extraOfferModal";

export const NearbyOffersPanel = (props: IProps) => {
    const {offersNearby, lastElement, modalQuery, gtmData} = props;

    const [minHeight, setMinHeight] = useState(0);
    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();

    useEffect(() => {
        const firstNearbyElement = document.getElementById(FIRST_NEARBY_ELEMENT_ID);

        if (firstNearbyElement && !minHeight) {
            setMinHeight(firstNearbyElement.offsetHeight);
        }
    }, []);

    const containerId = useGTMEcommerceShortOfferListTracking({
        offers: offersNearby,
        listingName: gtmData.listingName,
        country: gtmData.country
    });

    return (
        <>
            <ColumnList css={listStyle} id={containerId} data-id={containerId}>
                {offersNearby.map((offer, index) => (
                    <ColumnListItem key={offer.id} id={index === 0 ? FIRST_NEARBY_ELEMENT_ID : undefined}>
                        <OfferBox
                            offer={offer}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                        />
                    </ColumnListItem>
                ))}
                {lastElement ? (
                    <ColumnListItem key="last" style={{minHeight}}>
                        {lastElement}
                    </ColumnListItem>
                ) : null}
            </ColumnList>
            <OfferModal modalName="extraOfferModal" offersQuery={modalQuery} userPreferencePropertyFilters={userPreferencesFilters} />
        </>
    );
};

const listStyle = (theme: Theme) => css`
    padding-left: 0;
    padding-right: 0;
    @media (min-width: ${theme.breakpoints.lg}) {
        ul {
            max-width: 100%;
        }
    }
`;
import React, {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {ApplicationSourceSection} from "../application/utils/ApplicationSource";
import {ColumnList} from "../atoms/ColumnList";
import {ColumnListItem} from "../atoms/ColumnListItem";
import {OfferBox} from "../offer/components/offer_box/OfferBox";
import {OfferModal} from "../offer/components/offer_modal/OfferModal";
import {showOfferModal} from "../offer/state/offer_modals_slice";
import {IOfferListOffer} from "../offer/types/IOfferListOffer";
import {IOfferModalName} from "../offer/types/OfferModalName";
import {IOfferModalOffer} from "../offer/types/OfferModalOffer";
import {Country} from "../region/types/Country";
import {useAppDispatch} from "../store/hooks";
import {useGTMEcommerceShortOfferListTracking} from "../tracking/hooks/use_gtm_ecommerce_tracking";
import {useUserPreferencesFilters} from "../user/hooks/use_user_preferences_filters";

interface IProps {
    offersNearby: IOfferListOffer[];
    modalQuery: IInfiniteListQuery<IOfferModalOffer>;
    lastElement?: JSX.Element;
    onBoxClick?: (e: React.MouseEvent, offerId: number) => void;
    gtmData: {
        listingName: string;
        country: Country;
    };
}

const FIRST_NEARBY_ELEMENT_ID = "first-nearby-element";
const modalName: IOfferModalName = "extraOfferModal";

export const NearbyOffersPanel = (props: IProps) => {
    const {offersNearby, lastElement, modalQuery, gtmData} = props;

    const [minHeight, setMinHeight] = useState(0);
    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();

    useEffect(() => {
        const firstNearbyElement = document.getElementById(FIRST_NEARBY_ELEMENT_ID);

        if (firstNearbyElement && !minHeight) {
            setMinHeight(firstNearbyElement.offsetHeight);
        }
    }, []);

    const containerId = useGTMEcommerceShortOfferListTracking({
        offers: offersNearby,
        listingName: gtmData.listingName,
        country: gtmData.country
    });

    return (
        <>
            <ColumnList css={listStyle} id={containerId} data-id={containerId}>
                {offersNearby.map((offer, index) => (
                    <ColumnListItem key={offer.id} id={index === 0 ? FIRST_NEARBY_ELEMENT_ID : undefined}>
                        <OfferBox
                            offer={offer}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                        />
                    </ColumnListItem>
                ))}
                {lastElement ? (
                    <ColumnListItem key="last" style={{minHeight}}>
                        {lastElement}
                    </ColumnListItem>
                ) : null}
            </ColumnList>
            <OfferModal modalName="extraOfferModal" offersQuery={modalQuery} userPreferencePropertyFilters={userPreferencesFilters} />
        </>
    );
};

const listStyle = (theme: Theme) => css`
    padding-left: 0;
    padding-right: 0;
    @media (min-width: ${theme.breakpoints.lg}) {
        ul {
            max-width: 100%;
        }
    }
`;
